import { Control } from '@peckadesign/pd-naja/dist/types'

type StuckEdge = 'top' | 'bottom'

class Stuck implements Control {
	public static readonly selector = '.js-detect-stuck'
	private observer: IntersectionObserver

	public constructor() {
		this.observer = new IntersectionObserver(this.handleIntersection.bind(this), { threshold: 1 })
	}

	public initialize(context: Element | Document): void {
		const stuckElements = context.querySelectorAll(Stuck.selector)

		stuckElements.forEach((element) => this.observer.observe(element))
	}

	public destroy(context: Element): void {
		const stuckElements = context.querySelectorAll(Stuck.selector)

		stuckElements.forEach((element) => this.observer.unobserve(element))
	}

	private handleIntersection(entries: IntersectionObserverEntry[]) {
		entries.forEach((entry: IntersectionObserverEntry) => {
			if (!entry.target.isConnected || entry.rootBounds === null) {
				return
			}

			const edge: StuckEdge = ((entry.target as HTMLElement).dataset.stuckEdge || 'bottom') as StuckEdge
			let isStuck = false

			if (edge === 'top') {
				isStuck = entry.boundingClientRect.top < 0 && entry.intersectionRatio < 1
			} else if (edge === 'bottom') {
				isStuck = entry.rootBounds[edge] - entry.boundingClientRect[edge] < 0 && entry.intersectionRatio < 1
			}

			entry.target.classList.toggle('is-stuck', isStuck)
			entry.target.classList.toggle('not-stuck', !isStuck)
		})
	}
}

export default new Stuck()
